import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useSettingModal } from '../../../../hooks/Context';
import ViewDetails from './ViewDetails';
import DeleteClass from './DeleteClass';
import CreateCompanyClass from './CreateCompanyClass';
import css3 from '../../Applicants/css/applicant-table.module.css';
import { MdOutlineArrowBackIosNew as LBtn, MdOutlineArrowForwardIos as RBtn } from 'react-icons/md';
import { DropdownOption } from '../../../../customs/DropDownOption';
import { useQueryClient } from '@tanstack/react-query';
import EachRow from '../AdminUsers/EachRow';

interface RouteProps {
  Id: string;
  Name: string;
  NormalizedName: string;
}

interface RouteResponse {
  data: RouteProps[];
};

const CompanyClassTable = (props:any) => {
    const [menuIndex, setMenuIndex] = useState<null | number>(null);
    const [pageArr, setPageArr] = useState<number[]>([]);
    const [activeData, setActiveData] = useState<number[]>([]);
    const [currentPage, setCurrentPage] = useState<any>(0);
    const [optionModal, setOptionModal] = useState<any>('');
    const [toggleModal, setToggleModal] = useState<number>(0);
    const {setShowModal, setModalContent} = useSettingModal();
    const [aData, setAData] = useState<any>([]);
    const [userD, setUserD] = useState<any>({});
    const [roleByUserData, setRoleByUserData] = useState<RouteProps[]>([]);

    const queryClient = useQueryClient();
    const data = props.data;
    const filter = props.filter;
    const routeData = props.routeData;

    const tableHead = ["Classification", "Sector", "Annual subscriptions" ];

    const CompanyClassUserOptions = [
      "View Details",
      "Update Classification",
      "Delete Classification",
      
    ];
 
    const onChange = (opt: string, user: any) => {
      setOptionModal(opt);
      setToggleModal(toggleModal + 1);
      setUserD(user);
    };
   
    const handlePrevious = () => {
      if(currentPage === 0){
          if(pageArr.length > 1){
              setCurrentPage(pageArr.at(-1))
              return false;
          }
          setCurrentPage(0);
          return false;
      }
      setCurrentPage(currentPage-1);
    };
 
    const handleNext = () => {
      if(pageArr.length > 1){
        if(currentPage === pageArr.at(-1)) {
            setCurrentPage(0);
            return false;
        }
        setCurrentPage(currentPage+1);
        return false;
      }
      setCurrentPage(0);
    }

    const DATA_PER_PAGE = 10;

  // const roleError = getRoleByUserIdMutation?.error as AxiosError;
  // const roleErrorMessage = roleError?.message;

  
  useEffect(() => {
    if(optionModal){
      if(optionModal === 'View Details') setModalContent(<ViewDetails data={userD} />);
      if(optionModal === 'Update Classification') setModalContent(<CreateCompanyClass {...userD} />);
      if(optionModal === 'Delete Classification') setModalContent(<DeleteClass data={userD}/>);
      setShowModal(true); 
    }
  }, [optionModal, toggleModal, roleByUserData])
 
    useEffect(() => {
       let arr: number[] = [];
       if(aData.length > 0) {
          let pNumber = Math.ceil(aData.length/DATA_PER_PAGE);
          let i;
          for(i = 0; i < pNumber; i++){
            arr.push(i);
          }
        } 
        
        setPageArr(arr);
        setCurrentPage(0);
    },[aData])
    
    useEffect(()=>{
      if(filter){
       let arr:any = [];
       data.forEach((eData:any,index:number) =>{
         if(eData.RouteId.toLowerCase().includes(filter.toLowerCase())){
           arr.push(eData)
         }
       })
       if(arr.length > 0) setAData(arr); 
     }
     else{
       setAData(data);
     }
    
     setCurrentPage(0);
   },[filter])

    useEffect(()=>{
     setAData(data);
    },[data])
 
  useEffect(()=>{
   if(aData && aData.length > 0){    
     let start = currentPage * DATA_PER_PAGE;
     let stop = start + DATA_PER_PAGE;
     setActiveData(aData.slice(start,stop));  
   }
 },[currentPage,aData])
 
 
  return <CompanyClassTableContainer>
 
     <div>
       {tableHead.map((eSpan,index) => <span key={index}>{eSpan}</span>)}
     </div>
     <div style={{ position:"relative", zIndex:'1' }}>
       {activeData?.length > 0 &&  activeData.map((eUser:any, index:number) =>
         <EachRow key={index} index={index} 
         menuIndex={menuIndex} onClick={setMenuIndex}>
             <span>{eUser.ClassificationType}</span>
             <span>{eUser.SectorType}</span>
             {/* <span>{eUser.AnnualSubscription}</span> */}
             <span>
               <div>{eUser.AnnualSubscription}</div>
               <DropdownOption user={eUser} onChange={onChange} options={CompanyClassUserOptions} index={index} menuIndex={menuIndex} setMenuIndex={setMenuIndex} />
             </span>
         </EachRow>
       )}
       
     </div>
     <div className={css3.pagination}>
         <div>
             <button className={`${css3.lBtn} ${css3.btn}`} onClick={handlePrevious}><LBtn/></button>
             {pageArr && pageArr.length > 0 && pageArr.map((ePage: number, index: number) => {

              if(index <= 2 && currentPage <= 2) return (<span
                  style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                  key={ePage} 
                  onClick={() => setCurrentPage(ePage)}
              >
                  {ePage + 1}
              </span>)  

              if(index == currentPage ) return (<span
                  style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                  key={ePage} 
                  onClick={() => setCurrentPage(ePage)}
              >
                  {ePage + 1}
              </span>)  

              if(index >= pageArr.length - 3 && currentPage >= pageArr.length -3) return (<span
                  style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                  key={ePage} 
                  onClick={() => setCurrentPage(ePage)}
              >
                  {ePage + 1}
              </span>)  

              if(index == pageArr.length-1) return (
              <>
                  <>...</>
                  <span 
                  style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                  key={ePage} 
                  onClick={() => setCurrentPage(ePage)}
                  >
                      {ePage + 1}
                  </span>
              </>
              )  

              if(index == 0 ) return (
              <>
                  <span 
                  style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                  key={ePage} 
                  onClick={() => setCurrentPage(ePage)}
                  >
                      {ePage + 1}
                  </span>
                  <>...</>
              </>)  

              })} 
             <button className={`${css3.rBtn} ${css3.btn}`} onClick={handleNext}><RBtn/></button>
         </div>
     </div>
 
    </CompanyClassTableContainer>
 }

 export default CompanyClassTable;

 const CompanyClassTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap:10px;
  margin-top:20px;

  & > div:first-child{
    display:grid;
    grid-template-columns: repeat(3, 1fr);
    border-bottom: 1px solid #E2E4E9;
  }
  & > div:first-child > span{
    padding:10px;
  }

  & > div:nth-child(2){
    width:100%;
    display: flex;
    flex-direction: column;
    row-gap:5px;
    min-height: 300px;
  }
  & > div:nth-child(2) > div{
    display:grid;
    grid-template-columns: repeat(3,1fr);
    border-left:3px solid #fff;
    cursor: pointer;
    font-size:13px;
  }
  & > div:nth-child(2) > div:hover{
    border-left-color:#293856;
    background-color:#E0FAEE;
  }

  & > div:nth-child(2) >div > span:not(:last-child){
    padding: 7px 10px;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  }
  & > div:nth-child(2) > div > span:last-child{
    display:flex;
    justify-content:space-between;
    padding:0 10px;
    align-items:center;
    position:relative;
    /* z-index: 1; */

  }
  & > div:nth-child(2) > div > span:last-child > span{
    /* position: relative;
    padding:8px;
    background-color:#11643C;
    color:#fff;
    height:20px; */
    display:none;
    /* align-items: center;
    justify-content: center;
    border-radius: 3px;
    width:30px; */
  }
  & > div:nth-child(2) > div:hover > span:last-child > span{
    display:flex;
  }
  /* & > div:nth-child(2) > div > span:last-child > span.active{
     display: flex !important;
  } */

`